import React from "react";
import { CircleCheckBig } from "lucide-react";
import ProgressBar from "./ProgressBar";

// SystemCard
// Props:
// - title: string
// - mIcon: React component (passed as a prop, aliased to Icon inside)
// - value: number|string
// - totalValue: optional number|string
// - isPer: boolean (if true, show value as percentage)
// - progressPercentage: number (0-100) for ProgressBar — default 37
// - statusDelta: string shown on left of status row — default '20.8%'
// - statusText: string shown on right of status row — default 'Healthy'

export function SystemCard({
  title,
  mIcon,
  value,
  totalValue,
  isPer = false,
  progressPercentage,

  statusText = "Healthy",
}) {
  // mIcon may be passed in lowercase; alias to a capitalized local name so JSX treats it as a component
  const Icon = mIcon;
  const statusDelta = Number(progressPercentage).toFixed(1) + "%";
  return (
    <div
      className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl rounded-2xl p-4 border border-state-200/50 dark:border-slate-700/50 
           hover:shadow-xl hover:shadow-slate-900/20 transition-all duration-300 group "
    >
      <div className=" flex items-start justify-between">
        <div className=" w-full flex items-center space-x-2">
          {/* logo */}
          <div className="">
            {Icon ? <Icon className=" text-blue-600" /> : null}
          </div>
          {/* title */}
          <span className="text-sm text-black dark:text-slate-200">
            {title}
          </span>
          {/* check icon (right side) */}
          <div className="flex items-center justify-end ml-auto ">
            <CircleCheckBig className="w-4 h-4  text-blue-600" />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-start space-x-1 mt-2">
        <span className="text-xl font-bold text-black dark:text-slate-200 font-medium ">
          {isPer ? `${value}%` : value}
        </span>
        {totalValue && (
          <span className="text-sm text-black dark:text-slate-600 font-medium ">
            {"/" + totalValue}
          </span>
        )}
      </div>
      {/* Progress bar */}
      <div className="mt-2">
        <ProgressBar progressPercentage={progressPercentage} />
      </div>
      <div className="flex items-center justify-between space-x-2 mt-2">
        <span className="text-xs text-black/50 dark:text-slate-600">
          {statusDelta}
        </span>
        <h1 className="text-xs text-blue-600 dark:text-blue-600">
          {statusText}
        </h1>
      </div>
    </div>
  );
}
